/* eslint-disable import/no-anonymous-default-export */

import CompanyActionTypes from "./company.types";
import { docodeHexResponse } from "../../_common/common.utils";

const INITIAL_STATE = {
  addCompanyDetailsResponse: null,
  updateCompanyDetailsResponse: null,
  getCompanyListResponse: null,
  getCompanyListArr: [],
  fetchCompanyDetailsResponse: null,
  fetchCompanyDetailsArr: [],
  deleteCompanyDetailsResponse: null,
  addInstanceDetailsResponse: null,
  addInstanceName: null,
};

export default (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    /** ***************** ADD COMPANY DETAILS START *********************** */
    case CompanyActionTypes.ADD_COMPANY_DETAILS_SUCCESS:
      return { ...state, addCompanyDetailsResponse: action.payload };

    case CompanyActionTypes.ADD_COMPANY_DETAILS_FAILURE:
      return { ...state, addCompanyDetailsResponse: action.payload };

    case CompanyActionTypes.ADD_COMPANY_DETAILS_RESPONSE_CHANGED:
      return { ...state, addCompanyDetailsResponse: null };
    /** ***************** ADD COMPANY DETAILS END *********************** */

    /** ***************** UPDATE COMPANY DETAILS START *********************** */
    case CompanyActionTypes.UPDATE_COMPANY_DETAILS_SUCCESS:
      return { ...state, updateCompanyDetailsResponse: action.payload };

    case CompanyActionTypes.UPDATE_COMPANY_DETAILS_FAILURE:
      return { ...state, updateCompanyDetailsResponse: action.payload };

    case CompanyActionTypes.UPDATE_COMPANY_DETAILS_RESPONSE_CHANGED:
      return { ...state, updateCompanyDetailsResponse: null };
    /** ***************** UPDATE COMPANY DETAILS END *********************** */

    /** ***************** GET COMPANY DETAILS START *********************** */
    case CompanyActionTypes.GET_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        getCompanyListResponse: action.payload,
        getCompanyListArr: docodeHexResponse(
          action.payload,
          "GetAllCompanyPaginationKey",
        ),
      };

    case CompanyActionTypes.GET_COMPANY_LIST_FAILURE:
      return { ...state, getCompanyListResponse: action.payload };

    case CompanyActionTypes.GET_COMPANY_LIST_RESPONSE_CHANGED:
      return { ...state, getCompanyListResponse: null };
    /** ***************** GET COMPANY DETAILS END *********************** */

    /** ***************** FETCH COMPANY DETAILS START *********************** */
    case CompanyActionTypes.FETCH_COMPANY_DETAILS_SUCCESS:
      return {
        ...state,
        fetchCompanyDetailsResponse: action.payload,
        fetchCompanyDetailsArr: docodeHexResponse(
          action.payload,
          "GetCompanyKey",
        ),
      };

    case CompanyActionTypes.FETCH_COMPANY_DETAILS_FAILURE:
      return { ...state, fetchCompanyDetailsResponse: action.payload };

    case CompanyActionTypes.FETCH_COMPANY_DETAILS_RESPONSE_CHANGED:
      return {
        ...state,
        fetchCompanyDetailsResponse: null,
        fetchCompanyDetailsArr: [],
      };
    /** ***************** FETCH COMPANY DETAILS END *********************** */

    /** ***************** DELETE COMPANY DETAILS START *********************** */
    case CompanyActionTypes.DELETE_COMPANY_DETAILS_SUCCESS:
      return { ...state, deleteCompanyDetailsResponse: action.payload };

    case CompanyActionTypes.DELETE_COMPANY_DETAILS_FAILURE:
      return { ...state, deleteCompanyDetailsResponse: action.payload };

    case CompanyActionTypes.DELETE_COMPANY_DETAILS_RESPONSE_CHANGED:
      return { ...state, deleteCompanyDetailsResponse: null };
    /** *************** DELETE COMPANY DETAILS END *********************** */

    /** **************** ADD INSTANCE DETAILS START *********************** */
    case CompanyActionTypes.ADD_INSTANCE_DETAILS_SUCCESS:
      return {
        ...state,
        addInstanceDetailsResponse: action.payload,
        addInstanceName: action.payload,
      };

    case CompanyActionTypes.ADD_INSTANCE_DETAILS_FAILURE:
      return { ...state, addInstanceDetailsResponse: action.payload };

    case CompanyActionTypes.ADD_INSTANCE_DETAILS_RESPONSE_CHANGED:
      return { ...state, addInstanceDetailsResponse: null };
    /** *************** ADD INSTANCE DETAILS END *********************** */

    default:
      return state;
  }
};
